import {Button} from '@mui/material';
import Grid from '@mui/material/Grid';
import FreeSens from 'assets/img/FreeSensLogo.svg';
import ErrorSvg from 'assets/img/retry-page.svg';
import RefreshIcon from '@mui/icons-material/Refresh';
import {useNavigate} from 'react-router-dom';
import {detectPathUrl} from 'helpers/detectPathUrl';

export default function Error() {
  const navigate = useNavigate();
  const handleClick = () => {
    // history.goBack()
    const path = detectPathUrl('app/home');
    navigate(path, {replace: true});
  };
  return (
    <Grid container xs={12} justifyContent='center' alignItems='center'>
      <Grid item mt='28px' mb='85px'>
        <img src={FreeSens} alt='' />
      </Grid>
      <Grid item xs={12} textAlign='center' mb='38px'>
        <img src={ErrorSvg} alt='' />
      </Grid>
      <p
        style={{
          width: '100%',

          fontFamily: 'dana-bold',
          fontSize: '14px',
          lineHeight: '22px',
          textAlign: 'center',
          color: '#4E4E4E',
          marginBottom: '28px',
        }}>
        اشکال در برقراری ارتباط با شبکه!
      </p>
      <Button
        onClick={handleClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',

          width: '232px ',
          height: '48px',
          fontFamily: 'dana-bold',
          background: '#F5F5F5',
          border: '1px solid #FFFFFF',
          boxShadow:
            '4px 4px 15px rgba(172, 172, 172, 0.5), -4px -4px 15px #FFFFFF !important',
          borderRadius: '16px',
          color: '#753CBE !important',
        }}>
        <RefreshIcon
          sx={{
            position: 'absolute',
            margin: '0 auto',
            right: '25px',
          }}
        />
        <p>دوباره سعی کنید</p>
      </Button>
    </Grid>
  );
}
